// @/components/reusable/typography.jsx
// V2 Typography Components - Simple wrappers, style via className

import React from "react";
import clsx from "clsx";

// ============================================================================
// HEADING
// ============================================================================

export const Heading = ({ level = 1, className, children, ...props }) => {
  const Element = `h${level}`;
  return (
    <Element className={clsx(className)} {...props}>
      {children}
    </Element>
  );
};

// ============================================================================
// TEXT
// ============================================================================

export const Text = ({ className, children, ...props }) => (
  <p data-slot="text" className={clsx('text-pretty', className)} {...props}>
    {children}
  </p>
);

// ============================================================================
// LABEL
// ============================================================================

export const Label = ({ className, children, ...props }) => (
  <span className={clsx(className)} {...props}>
    {children}
  </span>
);

// ============================================================================
// DISPLAY
// ============================================================================

export const Display = ({ className, children, ...props }) => (
  <span className={clsx(className)} {...props}>
    {children}
  </span>
);

// ============================================================================
// SUFFIX
// ============================================================================

export const Suffix = ({ className, children, ...props }) => (
  <span className={clsx(className)} {...props}>
    {children}
  </span>
);
